import './search.scss';

import { createInstantSearchBlock } from '@boost-sd/theme/core/blocks/search';

const instantSearchBlock = createInstantSearchBlock();

instantSearchBlock.render();
